import React from "react";
import async from "./components/Async";

// Layouts
import DashboardLayout from "./layouts/Dashboard";

// Guards

// Auth components

import Page404 from "./pages/auth/Page404";

// Page components


// Documentation

// Protected routes

import SessionsAndProcesses from "./pages/pages/SessionsAndProcesses";

import OverProvisioning from "./pages/pages/reports/OverProvisioning";
import PrivilegeCreep from "./pages/pages/reports/HistoricalData/PrivilegeCreep";
import LocalUsers from "./pages/pages/reports/HistoricalData/LocalUsers";
import SuspiciousAccounts from "./pages/pages/reports/HistoricalData/SuspiciousAccounts";

import PrivateRoute from "./components/auth/PrivateRoute";
import ServiceTerms from "./pages/pages/ServiceTerms";
import Loader from "./components/Loader";
import OrganizationUnit from "./pages/pages/OrganizationUnit/OrganizationUnit";

import UserMembership from "./pages/pages/UserMembership/UserMembership";

import AwsRoles from "./pages/pages/AWS/AwsRoles";
import AWSGroups from "./pages/pages/AWS/AWSGroups";
import AzureGroups from "./pages/pages/Azure/AzureGroups";
import AzureDevices from "./pages/pages/Azure/AzureDevices";
import AzureUserInfo from "./pages/pages/Azure/Components/AzureUserInfo";
import AzureRoles from "./pages/pages/Azure/AzureRoles";
import GcpGroups from "./pages/pages/GCP/GcpGroups";
import GcpRoles from "./pages/pages/GCP/GcpRoles";
import GcpUserInfo from "./pages/pages/GCP/GcpUserInfo";
import ADAnalytics from "./pages/pages/ADAnalytics";
import { GraphProvider } from "./pages/pages/ADAnalytics/GraphContext";
import GCPAlerts from "./pages/pages/GCP/GCPAlerts";
import AzureAlerts from "./pages/pages/Azure/AzureAlerts";
import AWSAlerts from "./pages/pages/AWS/AWSAlerts";
import DeviceManagementDashboard from "./components/v2components/Endpoints/DeviceManagementDashboard";
import DeviceDetailPage from "./components/v2components/Endpoints/DeviceDetails/DeviceDetailPage";
import OverviewDetails from "./components/v2components/Overview/OverviewDetails";
import AlertDetails from "./components/v2components/Alerts/AlertsDetails";
import LolbinDetails from "./components/v2components/Lolbin/LolbinDetails";
import AuditLogsDetails from "./components/v2components/AuditLogs/AuditLogsDetails";
import ResourceRequestDetails from "./components/v2components/ResourceRequests/ResourceRequestDetails";
import PolicyProfileDetails from "./components/v2components/PolicyProfiles/PolicyProfileDetails";
import PolicyProfilesResources from "./components/v2components/PolicyProfiles/PolicyProfileResources";
import PolicyProfilesCategories from "./components/v2components/PolicyProfiles/PolicyProfilesCategories";
import ResourceCategoryDetails from "./components/v2components/ResourceCategory/ResourceCategoryDetails";
import WebUrlsTable from "./components/v2components/WebUrls/WebUrlsTable";
import AboutPage from "./components/v2components/About/AboutPage";
import DownloadPage from "./components/v2components/Downloads/DownloadPage";
import AccountPage from "./components/v2components/Account/AccountPage";
import EndpointGroupDetails from "./components/v2components/EndpointGroups/EndpointGroupDetails";
import TagsDetails from "./components/v2components/Tags/TagsDetails";
import PlatformAuditLogsDetails from "./components/v2components/PlatformAuditLogs/PlatformAuditLogsDetails";
import InviteUserDetails from "./components/v2components/InviteUsers/InviteUserDetails";
import UserRolesDetails from "./components/v2components/UserRoles/UserRolesDetails";
import RegisteredUserDetails from "./components/v2components/RegisteredUsers/RegisteredUserDetails";
import InviteAdUsers from "./components/v2components/ActiveDirectory/InviteAdUsers";
import WebUrlsDetails from "./components/v2components/WebUrls/WebUrlsDetails";
import PolicyProfilesSettings from "./components/v2components/PolicyProfiles/PolicyProfilesSettings";
import TenantUserDeviceDetails from "./components/v2components/TenantUserEndpoints/TenantUserDeviceDetails";
import TenantSettingDetails from "./components/v2components/TenantSettings/TenantSettingDetails";
import TenantDetailsPage from "./components/v2components/TenantDetails/TenantDetailsPage";
import Users from "./components/v2components/Cloud/Users";
import CloudNHIPage from "./components/v2components/CloudNHI/CloudNHIPage";
import AdminCloudResources from "./components/v2components/Cloud/Resources/AdminCloudResources";
import TenantCloudResources from "./components/v2components/TenantCloud/TenantCloudResources";
import TenantKubernetes from "./components/v2components/TenantCloud/TenantKubernetes";
import OuComputes from "./pages/pages/OuComputes/OuComputes";
import NHIServiceAccoutDetails from "./pages/pages/GCP/Components/NHIServiceAccoutDetails";
import AWSUserDetails from "./pages/pages/AWS/AWSUserDetails";
import GCPCloudAlerts from "./pages/pages/GCP/GCPCloudAlerts";
import AWSCloudAlerts from "./pages/pages/AWS/AWSCloudAlerts";
import AZURECloudAlerts from "./pages/pages/Azure/AZURECloudAlerts";
import { Navigate } from "react-router-dom";
import Index from "./components/v2components/CloudGraph/pages/Index";
import CloudAlertManagement from "./components/v2components/CloudAlertManagement/pages/AlertManagement.tsx";
import ActiveDirectoryManagement from "./components/v2components/ActiveDirectory/ActiveDirectoryManagement";
import ADServiceAccountAnalytics from "./components/v2components/ActiveDirectory/ADServiceAccountAnalytics";
import AuthSignIn from "./pages/pages/auth/AuthSignIn";
import ForgotPassword from "./pages/pages/auth/ForgotPassword";
import Auth from "./layouts/Auth";
import AuthSignUp from "./pages/pages/auth/AuthSignUp";
import CloudEntityAnalyticsBridge from "./components/v2components/CloudAnalytics/CloudEntityAnalyticsBridge";
import CloudDashboard from "./components/v2components/CloudDashboard/pages/Index";
import ConfiguredSaasAppsDetails from "./components/v2components/SaaSApps/ConfiguredSaasAppsDetails";
import VaultServiceManagement from "./components/v2components/VaultService/VaultServiceManagement";
import ADUserDetailsAnalytics from "./components/v2components/ActiveDirectory/ADUserDetailsAnalytics";
import ADAnalyticsGraph from "./components/v2components/ADAnalyticsGraph/pages/Index";

// Agentic Gateway pages
import GatewayHealthPage from "./components/v2components/AgenticGateway/pages/GatewayHealthPage";
import GatewayConfigPage from "./components/v2components/AgenticGateway/pages/GatewayConfigPage";
import GatewayServersPage from "./components/v2components/AgenticGateway/pages/GatewayServersPage";
import GatewayAgentsPage from "./components/v2components/AgenticGateway/pages/GatewayAgentsPage";
import GatewayIdentitiesPage from "./components/v2components/AgenticGateway/pages/GatewayIdentitiesPage";
import GatewayProfilesPage from "./components/v2components/AgenticGateway/pages/GatewayProfilesPage";
import GatewayPoliciesPage from "./components/v2components/AgenticGateway/pages/GatewayPoliciesPage";
import GatewayInflightPage from "./components/v2components/AgenticGateway/pages/GatewayInflightPage";
import GatewayAuditPage from "./components/v2components/AgenticGateway/pages/GatewayAuditPage";
import GatewayPlaygroundPage from "./components/v2components/AgenticGateway/pages/GatewayPlaygroundPage";
import GlobalAgenticActivity from "./components/v2components/AiAgentActivity/GlobalAgenticActivity";

// Dashboard components
// const Default = async(() => import("./pages/dashboards/Default"));
const Analytics = async(() => import("./pages/dashboards/Analytics"));

// Icon components
const admin = "TENANT_ADMIN";
const sysAdmin = "SYS_ADMIN";
const user = "TENANT_USER";

const routes = [
  {
    path: "/cloud-analytics-view",
    element: <Index />
  },

  {
    path: "tenantDetails",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "",
        element: <TenantDetailsPage />,
      },
    ],
  },
  {
    path: "userInvites",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<InviteUserDetails />} />}
      />
    ),
  },
  {
    path: "adUsers",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<InviteAdUsers />} />}
      />
    ),
  },

  {
    path: "registeredUsers",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<RegisteredUserDetails />} />}
      />
    ),
  },
  {
    path: "roles",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<UserRolesDetails />} />}
      />
    ),
  },
  {
    path: "tenantSettings",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<TenantSettingDetails />} />}
      />
    ),
  },


  {
    path: "endpointGroups",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "",
        element: <EndpointGroupDetails />,
      },
    ],
  },
  {
    path: "tags",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "",
        element: <TagsDetails />,
      },
    ],
  },
  {
    path: "webUrls",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "",
        element: <WebUrlsTable />,
      },
      {
        path: "webUrldetails/:id",
        element: <WebUrlsDetails />,
      },
    ],
  },
  {
    path: "configuredSaasApps",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "",
        element: <ConfiguredSaasAppsDetails />,
      },
    ],
  },
  {
    path: "vault-services",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "",
        element: <VaultServiceManagement />,
      },

    ],
  },
  {
    path: "endpoints",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "",
        element: <DeviceManagementDashboard />,
      },
      {
        path: "sessions",
        element: <SessionsAndProcesses />,
      },



      {
        path: "deviceDetails/:id",
        element: <DeviceDetailPage />,
      },
      {
        path: "tenantdevice/:deviceId",
        element: <TenantUserDeviceDetails />
      }
    ],
  },
  {
    path: "loading",
    element: <Loader />,
  },
  {
    path: "terms_of_service",
    element: <ServiceTerms />,
  },
  {
    path: "/",
    element: <AuthSignIn />,
  },
  {
    path: "signIn",
    element: <AuthSignIn />,
  },
  {
    path: "forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "signUp",
    element: <AuthSignUp />,
  },

  {
    path: "dashboard",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "overview",
        element: <OverviewDetails onSelectorChange={() => { }} fromdetails={false} />,
      },
      {
        path: "analytics",
        element: <Analytics />,
      },
      {
        path: "alerts",
        element: <AlertDetails fromdetails={false} />,
      },
      {
        path: "agenticactivity",
        element: <GlobalAgenticActivity />,
      },
      {
        path: "lolbin",
        element: <LolbinDetails fromdetails={false} />,
      },
      {
        path: "cloud-analytics",
        element: <Navigate to="/cloud-analytics-view" replace />,
      },
      {
        path: "cloud-alert-managemant",
        element: <CloudAlertManagement />,
      },
      {
        path: "cloud-dashboard",
        element: <CloudDashboard />
      },
      {
        path: "cloud-entity-analytics",
        element: <CloudEntityAnalyticsBridge />
      },
    ],
  },
  {
    path: "policyProfiles",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),

    children: [
      {
        path: "",
        element: <PolicyProfileDetails />,
      },
      {
        path: "resources/:id/:os",
        element: <PolicyProfilesResources />,
      },
      {
        path: "categories/:id/:os/:osType",
        element: <PolicyProfilesCategories />,
      },
      {
        path: "settings/:id/:os/:osType",
        element: <PolicyProfilesSettings />,
      },
    ],
  },

  {
    path: "resourceRequests",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<ResourceRequestDetails />} />}
      />
    ),
  },
  {
    path: "resourceCategories",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<ResourceCategoryDetails />} />}
      />
    ),
  },
  {
    path: "userResourceRequests",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout children={<ResourceRequestDetails />} />}
      />
    ),
  },

  {
    path: "serverAuditLogs",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={<DashboardLayout children={<PlatformAuditLogsDetails />} />}
      />
    ),
  },
  {
    path: "auditLogs",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin]}
        element={
          <DashboardLayout
            children={<AuditLogsDetails fromdetails={false} />}
          />
        }
      />
    ),
  },


  {
    path: "aws",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "cloud-alerts",
        element: <AWSCloudAlerts />,
      },
      // {
      //   path: "awsalerts",
      //   element: <AWSAlerts />,
      // },
      {
        path: "users",
        element: <Users cloudProvider={"aws"} />,
      },
      {
        path: "roles",
        element: <AwsRoles />,
      },
      {
        path: "groups",
        element: <AWSGroups />,
      },
      {
        path: "resources",
        element: <AdminCloudResources cloudProvider={"aws"} />,
      },
      {
        path: "tenantk8",
        element: <TenantKubernetes cloudProvider={"aws"} />,
      },
      {
        path: "users/userDetails",
        element: <AWSUserDetails />,
      },
      {
        path: "tenantresources",
        element: <TenantCloudResources cloudProvider={"aws"} />,
      },
      {
        path: "nhis",
        element: <CloudNHIPage cloudProvider={"aws"} />,
      },
      {
        path: "nhi/service-account-details",
        element: <NHIServiceAccoutDetails />,
      },


      {
        path: "kubernetes",
        element: <TenantKubernetes cloudProvider={"aws"} />,
      },
    ],
  },
  {
    path: "activeDirectory",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "organizationUnit",
        element: <OrganizationUnit />,
      },
      {
        path: "userMembership",
        element: <UserMembership />,
      },
      {
        path: "computers",
        element: <OuComputes />,
      },
      {
        path: "analytics",
        element: <ADAnalyticsGraph />,
      },
      {
        path: "management",
        element: <ActiveDirectoryManagement />,
      },
      {
        path: "service/:id/:name",
        element: <ADServiceAccountAnalytics />,
      },
      {
        path: "user/:id/:name/:samAccountName",
        element: <ADUserDetailsAnalytics />,
      },
    ],
  },
  {
    path: "azure-directory",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "cloud-alerts",
        element: <AZURECloudAlerts />,
      },
      // {
      //   path: "azurealerts",
      //   element: <AzureAlerts />,
      // },
      {
        path: "devices",
        element: <AzureDevices />,
      },
      {
        path: "groups",
        element: <AzureGroups />,
      },
      {
        path: "azureusers",
        element: <Users cloudProvider={"azure"} />,
      },
      {
        path: "roles",
        element: <AzureRoles />,
      },
      {
        path: "nhis",
        element: <CloudNHIPage cloudProvider={"azure"} />,
      },
      {
        path: "nhi/service-account-details",
        element: <NHIServiceAccoutDetails />,
      },

      {
        path: "resources",
        element: <AdminCloudResources cloudProvider={"azure"} />,
      },
      {
        path: "tenantk8",
        element: <TenantKubernetes cloudProvider={"azure"} />,
      },

      {
        path: "tenantresources",
        element: <TenantCloudResources cloudProvider={"azure"} />,
      },



      {
        path: "azureusers/userDetails",
        element: <AzureUserInfo />,
      },
      {
        path: "kubernetes",
        element: <TenantKubernetes cloudProvider={"azure"} />,
      },
    ],
  },

  {
    path: "gcp",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout />}
      />
    ),
    children: [
      {
        path: "groups",
        element: <GcpGroups />,
      },
      {
        path: "cloud-alerts",
        element: <GCPCloudAlerts />,
      },
      // {
      //   path: "gcpalerts",
      //   element: <GCPAlerts />,
      // },
      {
        path: "gcpusers",
        element: <Users cloudProvider={"gcp"} />,
      },
      {
        path: "nhis",
        element: <CloudNHIPage cloudProvider={"gcp"} />,
      },

      {
        path: "nhi/service-account-details",
        element: <NHIServiceAccoutDetails />,
      },
      {
        path: "tenantk8",
        element: <TenantKubernetes cloudProvider={"gcp"} />,
      },

      {
        path: "tenantresources",
        element: <TenantCloudResources cloudProvider={"gcp"} />,
      },


      {
        path: "resources",
        element: <AdminCloudResources cloudProvider={"gcp"} />,
      },
      {
        path: "roles",
        element: <GcpRoles />,
      },
      {
        path: "gcpusers/userDetails",
        element: <GcpUserInfo />,
      },

      {
        path: "kubernetes",
        element: <TenantKubernetes cloudProvider={"gcp"} />,
      },
    ],
  },
  {
    path: "reports",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      {
        path: "overProvisioning",
        element: <OverProvisioning />,
      },
      {
        path: "privilegeCreep",
        element: <PrivilegeCreep />,
      },
    ],
  },

  {
    path: "localUsers",
    element: <DashboardLayout children={<LocalUsers />} />,
  },
  {
    path: "suspiciousAccounts",
    element: <DashboardLayout children={<SuspiciousAccounts />} />,
  },

  {
    path: "account",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout children={<AccountPage />} />}
      />
    ),
  },
  {
    path: "downloads",
    element: (
      <PrivateRoute
        access={[admin, sysAdmin, user]}
        element={<DashboardLayout children={<DownloadPage />} />}
      />
    ),
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "about",
        element: <AboutPage />,
      },
    ],
  },
  {
    path: "*",
    element: <Page404 />,
  },

  {
    path: "",
    element: <DashboardLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
  // ── Agentic Gateway ──────────────────────────────────────
  {
    path: "agentic-gateway",
    element: (
      <PrivateRoute access={[admin, sysAdmin]} element={<DashboardLayout />} />
    ),
    children: [
      { path: "health", element: <GatewayHealthPage /> },
      { path: "config", element: <GatewayConfigPage /> },
      { path: "servers", element: <GatewayServersPage /> },
      { path: "agents", element: <GatewayAgentsPage /> },
      { path: "identities", element: <GatewayIdentitiesPage /> },
      { path: "profiles", element: <GatewayProfilesPage /> },
      { path: "policies", element: <GatewayPoliciesPage /> },
      { path: "inflight", element: <GatewayInflightPage /> },
      { path: "audit", element: <GatewayAuditPage /> },
      { path: "playground", element: <GatewayPlaygroundPage /> },
    ],
  },
];

export default routes;
